export default "__VITE_ASSET__DA2ee93H__"